import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceCompanyActions from './company.actions';
import { CorrespondenceCompanyService } from '../../services/company.service';

@Injectable()
export class CorrespondenceCompanyEffects {
  loadCorrespondenceCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceCompanyActions.loadCorrespondenceCompany),
      exhaustMap((_) =>
        this.correspondenceCompanyService.getCorrespondenceCompany().pipe(
          map((data) =>
            CorrespondenceCompanyActions.loadCorrespondenceCompanySuccess({
              correspondenceCompany: data,
            })
          ),
          catchError((error) =>
            of(
              CorrespondenceCompanyActions.loadCorrespondenceCompanyFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addCorrespondenceCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceCompanyActions.addCorrespondenceCompany),
      concatMap(({ newCorrespondenceCompany }) =>
        this.correspondenceCompanyService
          .createCorrespondenceCompany(newCorrespondenceCompany)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceCompanyActions.addCorrespondenceCompanySuccess(
                {
                  newCorrespondenceCompany: data,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceCompanyActions.addCorrespondenceCompanyFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateCorrespondenceCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceCompanyActions.updateCorrespondenceCompany),
      map((action) => action.updateCorrespondenceCompany),
      concatMap((updateCorrespondenceCompany) =>
        this.correspondenceCompanyService
          .updateCorrespondenceCompany(updateCorrespondenceCompany)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceCompanyActions.updateCorrespondenceCompanySuccess(
                {
                  updateCorrespondenceCompany: updateCorrespondenceCompany,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceCompanyActions.updateCorrespondenceCompanyFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  removeCorrespondenceCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CorrespondenceCompanyActions.removeCorrespondenceCompany),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceCompanyService.deleteCorrespondenceCompany(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CorrespondenceCompanyActions.removeCorrespondenceCompanySuccess(
              { ids }
            );
          }),
          catchError((error) =>
            of(
              CorrespondenceCompanyActions.updateCorrespondenceCompanyFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceCompanyService: CorrespondenceCompanyService,
    private notification: NotificationService
  ) {}
}
